module.exports = __webpack_public_path__ + "static/media/car-image.7b76d543.svg";